module.exports = __webpack_public_path__ + "img/search-icon.4e38d063.svg";